<!-- Header -->
<div mat-dialog-title>
  {{ 'GROUPS_DIALOG.Title' | translate }}
  <div class="spacer"></div>
  <mat-icon class="pointer" (click)="close()">close</mat-icon>
</div>
<!-- Content -->
<mat-dialog-content>
  <p>
    {{ 'GROUPS_DIALOG.Message_1' | translate }}
  </p>
  <p>
    {{ 'GROUPS_DIALOG.Message_2' | translate }}
  </p>
</mat-dialog-content>
<!-- Footer -->
<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="goToGroups()">
    {{ 'GROUPS_DIALOG.Go_To_Groups' | translate }}
  </button>
</mat-dialog-actions>
